import { render, staticRenderFns } from "./vip-msg-expire-box.vue?vue&type=template&id=b0cbaff0&scoped=true&"
import script from "./vip-msg-expire-box.vue?vue&type=script&lang=js&"
export * from "./vip-msg-expire-box.vue?vue&type=script&lang=js&"
import style0 from "./vip-msg-expire-box.vue?vue&type=style&index=0&id=b0cbaff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cbaff0",
  null
  
)

export default component.exports